// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3TN3J","unreadBadge":"styles_unreadBadge__12kHt","modalContent":"styles_modalContent__1Xlh0","modal":"styles_modal__1WIkX"};